var React = require('react');

function InstagramInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1269","data-name":"Path 1269","d":"M404.239,20H386.73A2.727,2.727,0,0,0,384,22.724V40.246a2.727,2.727,0,0,0,2.73,2.724h17.509a2.727,2.727,0,0,0,2.73-2.724V22.724A2.727,2.727,0,0,0,404.239,20Zm-3.012,2.871h2.153a.718.718,0,0,1,.718.718v2.153a.718.718,0,0,1-.718.718h-2.153a.718.718,0,0,1-.718-.718V23.589A.718.718,0,0,1,401.227,22.871ZM395.511,27.1a4.407,4.407,0,1,1-4.417,4.407A4.412,4.412,0,0,1,395.511,27.1ZM404.1,40.816H386.871a.718.718,0,0,1-.718-.718V29.331h2.871a4.385,4.385,0,0,0-.5,2.18,6.987,6.987,0,0,0,13.975,0,3.675,3.675,0,0,0-.554-2.18h2.871V40.1A.718.718,0,0,1,404.1,40.816Z","transform":"translate(-384 -20)","fill":"#fff"}));
}

InstagramInline.defaultProps = {"width":"22.97","height":"22.97","viewBox":"0 0 22.97 22.97"};

module.exports = InstagramInline;

InstagramInline.default = InstagramInline;
